import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

export interface MenuItem {
  id: number;
  name: string;
  icon: string;
  class: string;
  children: MenuItem[];
  routerLink: string;
  open: boolean;
  isParent: boolean;
  order: number;
  otherRoles?: number[];
}

export const MENUITEMSIDENAV: MenuItem[] = [
  {
    id: 1,
    name: "داشبورد",
    icon: "home",
    class: null,
    children: [],
    open: false,
    routerLink: "/dashboard",
    order: 1,
    isParent: true,
    otherRoles: [1],
  },
  {
    id: 2,
    name: "مدیریت نقش‌ها",
    icon: "person",
    class: null,
    children: [],
    open: false,
    routerLink: "/role",
    order: 2,
    isParent: true,
    otherRoles: [2],
  },
  {
    id: 11,
    name: "مدیریت آگهی‌ها",
    icon: "announcement",
    class: null,
    children: [
      {
        id: 23,
        name: "آگهی‌های رایگان",
        icon: "money_off",
        class: null,
        children: [],
        open: false,
        routerLink: "free",
        order: 23,
        isParent: false,
      },
      {
        id: 24,
        name: "آگهی‌های ویژه",
        icon: "attach_money",
        class: null,
        children: [],
        open: false,
        routerLink: "pro",
        order: 24,
        isParent: false,
      },
      {
        id: 25,
        name: "آگهی‌های منقضی",
        icon: "timer_off",
        class: null,
        children: [],
        open: false,
        routerLink: "expire",
        order: 25,
        isParent: false,
      },
      {
        id: 26,
        name: "آگهی‌های خودم",
        icon: "tag_faces",
        class: null,
        children: [],
        open: false,
        routerLink: "me",
        order: 26,
        isParent: false,
      },
    ],
    open: false,
    routerLink: "/manage-posts",
    order: 11,
    isParent: true,
    otherRoles: [1],
  },
  {
    id: 27,
    name: "مدیریت قراردادها",
    icon: "attachment",
    class: null,
    children: [],
    open: false,
    routerLink: "/contract",
    order: 27,
    isParent: true,
    otherRoles: [1, 2],
  },
  {
    id: 28,
    name: "مدیریت تخفیف‌ها",
    icon: "money",
    class: null,
    children: [],
    open: false,
    routerLink: "/discount",
    order: 28,
    isParent: true,
    otherRoles: [],
  },
  {
    id: 3,
    name: "مدیریت تبلیغات",
    icon: "view_module",
    class: null,
    children: [],
    open: false,
    routerLink: "/advertisement",
    order: 3,
    isParent: true,
    otherRoles: [1],
  },
  {
    id: 4,
    name: "مدیریت تیکت‌ها",
    icon: "receipt",
    class: null,
    children: [],
    open: false,
    routerLink: "/ticket",
    order: 4,
    isParent: true,
    otherRoles: [1],
  },
  {
    id: 5,
    name: "مدیریت دسته‌ها",
    icon: "category",
    class: null,
    children: [],
    open: false,
    routerLink: "/category",
    order: 5,
    isParent: true,
    otherRoles: [1],
  },
  {
    id: 6,
    name: "مدیریت مقالات",
    icon: "menu_book",
    class: null,
    children: [
      {
        id: 21,
        name: "مدیریت دسته‌ها",
        icon: "category",
        class: null,
        children: [],
        open: false,
        routerLink: "category",
        order: 21,
        isParent: false,
      },
      {
        id: 22,
        name: "مدیریت لیست مقالات",
        icon: "library_books",
        class: null,
        children: [],
        open: false,
        routerLink: "magazines",
        order: 22,
        isParent: false,
      },
    ],
    open: false,
    routerLink: "/blog",
    order: 6,
    isParent: true,
    otherRoles: [1],
  },
  {
    id: 12,
    name: "مدیریت مناطق",
    icon: "zoom_out_map",
    class: null,
    children: [],
    open: false,
    routerLink: "/region",
    order: 12,
    isParent: true,
    otherRoles: [1],
  },
  {
    id: 7,
    name: "مدیریت نیازمندی‌ها",
    icon: "assignment",
    class: null,
    children: [],
    open: false,
    routerLink: "/requirement",
    order: 7,
    isParent: true,
    otherRoles: [1],
  },

  // {
  //   id: 8,
  //   name: 'مدیریت چینش صفحه اصلی',
  //   icon: 'list',
  //   class: null,
  //   children: [],
  //   open: false,
  //   routerLink: '/arrangement',
  //   order: 8,
  //   isParent: true,
  // }
  // ,
  {
    id: 8,
    name: "مدیریت پیام‌ها",
    icon: "message",
    class: null,
    children: [
      {
        id: 23,
        name: "پیام‌های ادمین",
        icon: "email",
        class: null,
        children: [],
        open: false,
        routerLink: "adminMessages",
        order: 23,
        isParent: false,
      },
      {
        id: 24,
        name: "پیام‌های عمومی",
        icon: "public",
        class: null,
        children: [],
        open: false,
        routerLink: "publicMessages",
        order: 24,
        isParent: false,
      },
      {
        id: 25,
        name: "اطلاعات فرم رویداد",
        icon: "public",
        class: null,
        children: [],
        open: false,
        routerLink: "event-registration",
        order: 25,
        isParent: false,
      },
    ],
    open: false,
    routerLink: "/message",
    order: 8,
    isParent: true,
    otherRoles: [1],
  },
  {
    id: 29,
    name: "لاگ سیستم",
    icon: "pending_actions",
    class: null,
    children: [],
    open: false,
    routerLink: "/log",
    order: 29,
    isParent: true,
    otherRoles: [],
  },

  {
    id: 9,
    name: "تنظیمات",
    icon: "settings",
    class: null,
    children: [],
    open: false,
    routerLink: "/settings",
    order: 9,
    isParent: true,
    otherRoles: [],
  },
  {
    id: 10,
    name: "قوانین",
    icon: "list",
    class: null,
    children: [],
    open: false,
    routerLink: "/rules",
    order: 10,
    isParent: true,
    otherRoles: [1],
  },
  {
    id: 11,
    name: "درباره ما",
    icon: "info",
    class: null,
    children: [],
    open: false,
    routerLink: "/aboutUs",
    order: 11,
    isParent: true,
    otherRoles: [1],
  },
  {
    id: 13,
    name: "ارتباط با ما",
    icon: "contact_phone",
    class: null,
    children: [],
    open: false,
    routerLink: "/contactUs",
    order: 13,
    isParent: true,
    otherRoles: [1],
  },
  {
    id: 14,
    name: "مدیریت برندها",
    icon: "list",
    class: null,
    children: [],
    open: false,
    routerLink: "/brands",
    order: 14,
    isParent: true,
  },
  {
    id: 15,
    name: "مدیریت اعطای نمایندگی",
    icon: "view_module",
    class: null,
    children: [],
    open: false,
    routerLink: "/agency-request",
    order: 15,
    isParent: true,
  },
];

@Injectable()
export class MenuItemSidenav {
  constructor(private router: Router) {}
  getAll(): MenuItem[] {
    return MENUITEMSIDENAV;
  }
}
